module.exports = __webpack_public_path__ + "img/saveToList.e99ed5ad.svg";